import { Props as LbCardData } from "../components/LeaderboardCard";
const allLbRoutes = ["sparkly-trees", "business-trees", "members-trees"];

export const getOtherLeaderboards = (currentRouteUrl: string): LbCardData[] => {
  return allLbRoutes
    .filter((route) => route !== currentRouteUrl)
    .map((route) => {
      const lbFor = route.slice(0, route.indexOf("-"));
      return {
        title: `Top tree planting ${lbFor} leaderboard`,
        navigateTo: `/leaderboards/${lbFor}`,
        bgImg: `/images/app/leaderboard/${lbFor}.png`,
      };
    });
};
